export default "__VITE_ASSET__Dnx9dLrm__"